import { render, staticRenderFns } from "./AddOrgPruductPay.vue?vue&type=template&id=26eb2ff1&scoped=true"
import script from "./AddOrgPruductPay.vue?vue&type=script&lang=js"
export * from "./AddOrgPruductPay.vue?vue&type=script&lang=js"
import style0 from "./AddOrgPruductPay.vue?vue&type=style&index=0&id=26eb2ff1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eb2ff1",
  null
  
)

export default component.exports